window.onscroll = function(e) {
	if (this.oldScroll > this.scrollY) {
		document.body.classList.remove('scroll-direction-down')
	} else {
		if (window.scrollY > 300) {
			document.body.classList.add('scroll-direction-down')			
		}
	}
	this.oldScroll = this.scrollY;
  }